module.exports = __webpack_public_path__ + "img/masterpass.a399a81a.png";